module.exports = __webpack_public_path__ + "img/page-19.12860c7b.jpg";